import Vue from 'vue'

const $Bus = new Vue()

const FLAG_PRODUCT_LIST = 'FLAG_PRODUCT_LIST' // 商品列表变化
const FLAG_FLASHSALESMINE = 'FLAG_FLASHSALESMINE' // 我报名的秒杀
const FLAG_TDSIGNUOMINE = 'FLAG_TDSIGNUOMINE' // 我报名的td
const FLAG_PRODUCTSKU = 'FLAG_PRODUCTSKU' // 商品详情
const FLAG_ORDERSALES = 'FLAG_ORDERSALES' // 销售单
const FLAG_SHIPPACKAGE = 'FLAG_SHIPPACKAGE' // 发运单
const FLAF_SHIPPACKAGEDETAILS = 'FLAF_SHIPPACKAGEDETAILS' // 发运单详情
const FLAG_GROUPSIGNUPMINE = 'FLAG_GROUPSIGNUPMINE' // 我报名的参团
const FLAG_BIGPROMOTIONMINE = 'FLAG_BIGPROMOTIONMINE' // 我参与的大促
const FLAG_NAVLEFT = 'FLAG_NAVLEFT' // 导航栏变化
const MESSAGE_CLOSE = 'MESSAGE_CLOSE' // 导航栏变化
const flagAfterSale = 'flagAfterSale'
const FlashRefreshList = 'FlashRefreshList'
const FLAG_ORDERLIST = 'FLAG_ORDERLIST' // 新订单状态改变时更新
const FLASH_REFRESH = 'FLASH_REFRESH' // 秒杀刷新
const BusObject = {
  $Bus,
  BusEvent: {
    FLAG_PRODUCT_LIST,
    FLAG_FLASHSALESMINE,
    FLAG_TDSIGNUOMINE,
    FLAG_PRODUCTSKU,
    FLAG_ORDERSALES,
    FLAG_SHIPPACKAGE,
    FLAF_SHIPPACKAGEDETAILS,
    FLAG_GROUPSIGNUPMINE,
    FLAG_BIGPROMOTIONMINE,
    FLAG_NAVLEFT,
    flagAfterSale,
    MESSAGE_CLOSE,
    FlashRefreshList,
    FLAG_ORDERLIST,
    FLASH_REFRESH
  }
}
export default BusObject
